'use strict';

var React = require('react');
require('prop-types');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var SocialMediaIconsSelection = require('./SocialMediaIconsSelection.js');
var GridWithSpacing = require('../../common/GridWithSpacing.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function SocialMediaEditForm(_ref) {
  var links = _ref.links,
      onFormChange = _ref.onFormChange;
  return React__default["default"].createElement(GridWithSpacing, {
    spacing: 24
  }, Object.keys(links).map(function (key, index) {
    return React__default["default"].createElement(Grid, {
      item: true,
      container: true,
      justify: "flex-end",
      alignItems: "center",
      xs: 12,
      spacing: 16,
      key: "".concat(index, "-").concat(key, "-form")
    }, React__default["default"].createElement(Grid, {
      item: true,
      xs: true
    }, React__default["default"].createElement(SocialMediaIconsSelection, {
      socialMediaName: key
    })), React__default["default"].createElement(Grid, {
      item: true
    }, React__default["default"].createElement(Typography["default"], {
      variant: "body2"
    }, "www.".concat(key, ".com/"))), React__default["default"].createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, React__default["default"].createElement(TextField["default"], {
      variant: "outlined",
      defaultValue: getPathFromUrl(links[key]),
      onChange: function onChange(event) {
        return onFormChange(key, event);
      },
      fullWidth: true,
      autoFocus: !index
    })));
  }));
}

function getPathFromUrl(url) {
  if (url.slice(-1) === '/') {
    url = url.substring(0, url.length - 1);
  }

  return ObjectHelper.isPresent(url) ? url.substring(url.lastIndexOf('/') + 1) : '';
}

SocialMediaEditForm.defaultProps = {
  links: {
    facebook: '',
    twitter: '',
    instagram: ''
  },
  onFormChange: function onFormChange() {}
};

module.exports = SocialMediaEditForm;
